import { ScreenRecognitionProvider } from '@phx-husky/screen-recognition';
import { GatsbyBrowser } from 'gatsby';
import React from 'react';

import ExternalLinkDialogProvider from '~/context/ExternalLinkDialogContext';

export const wrapWithProviders: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => (
  <ScreenRecognitionProvider>
    <ExternalLinkDialogProvider>{element}</ExternalLinkDialogProvider>
  </ScreenRecognitionProvider>
);
